// extracted by mini-css-extract-plugin
export var title = "ProgramOverviewBlock-module--title--1QLRY";
export var programsContainer = "ProgramOverviewBlock-module--programs-container--1e56P";
export var programCard = "ProgramOverviewBlock-module--program-card--2He7f";
export var open = "ProgramOverviewBlock-module--open--3gpET";
export var programName = "ProgramOverviewBlock-module--program-name--2j8-L";
export var programDescription = "ProgramOverviewBlock-module--program-description--2Neyd";
export var programBenefits = "ProgramOverviewBlock-module--program-benefits--2-4Hw";
export var programBenefit = "ProgramOverviewBlock-module--program-benefit--3DLj2";